import React from 'react';

import {AttachOverlay} from 'app/general/overlays';
import {gt} from 'app/utils/i18n';

import {EditExpiryTokenTimePopover} from '../EditExpiryTokenTimePopover';

import type {UserSerializedType} from 'sweet-types';

interface Props {
  user: UserSerializedType;
}

export function UpdateGuestExpirationButton({user}: Props): JSX.Element {
  return (
    <AttachOverlay
      trigger="click legacy"
      overlay={({overlayProps}) => (
        <EditExpiryTokenTimePopover overlayProps={overlayProps} user={user} />
      )}
    >
      {(triggers) => (
        <button className="btn alert-link btn-sm ml-2" {...triggers}>
          {gt('Update access expiry')}
        </button>
      )}
    </AttachOverlay>
  );
}
